<template>
  <app-bar title="Upcoming" :member-id="$route.params.memberId" />
  <v-list class="bg-transparent text-start" lines="two">
    <member-history-item
      v-for="booking in bookingList"
      :key="booking.booking_id"
      :title="`${booking.topic} (${booking.instructor})`"
      :subtitle="moment(booking.datetime).format('MMM DD, YYYY HH:mm')"
      :booking="booking"
      :allow-cancel="booking.is_allow_cancel"
      :cancel-func="onCancelClass"
    ></member-history-item>
  </v-list>
  <p v-if="bookingList.length == 0" class="mt-5">No Upcoming Class</p>
</template>

<script setup>
import AppBar from "@/components/AppBar.vue";
import axios from "axios";
import MemberHistoryItem from "@/components/MemberHistoryItem.vue";
import BackendConnector from "@/util/BackendConnector";
import { useRoute } from "vue-router";
import { ref } from "vue";
import moment from "moment";

const route = useRoute();
const bookingList = ref([]);

loadUpcoming(route.params.memberId).then((response) => {
  bookingList.value = response.data;
});

function onCancelClass(booking) {
  return BackendConnector.cancelClassBooking(booking.booking_id).then(() =>
    loadUpcoming(route.params.memberId).then((response) => {
      bookingList.value = response.data;
    })
  );
}

function loadUpcoming(memberId) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/classroom_booking/upcoming`,
    params: { member_id: memberId },
  });
}
</script>

<style scoped>
.list-prepend-icon {
  font-size: 2.4rem;
}
</style>
